export class Constant{
    static DEFAULT_DATE_TIME_FORMAT: string = "MM/dd/yyyy HH:mm";
    static DATE_TIME_FORMAT: string = "MM/dd/yyyy HH:mm:ss";
    static DATE_FORMAT: string = "MM/dd/yyyy";
    static DEFAULT_DATE_FORMATS: string[] = [Constant.DATE_FORMAT, Constant.DEFAULT_DATE_TIME_FORMAT, Constant.DATE_TIME_FORMAT];
}